import { forwardRef } from 'react'
import cn from 'clsx'
import { Tag } from '../tag'
import { type TWaveformLoaderProps } from './Waveform.types'
import styles from './Waveform.module.css'

const STROKE = {
    dark: 'var(--audio-background-inactive)',
    light: 'var(--audio-content-inactive)',
}

export const WaveformLoader = forwardRef<HTMLDivElement, TWaveformLoaderProps>(
    ({ id, variant = 'dark', text, className, paused = false }, ref) => (
        <div ref={ref} className={cn(styles.wrapper, className)}>
            <div className={styles.loaderInner}>
                <svg className={styles.loaderSvg} data-paused={paused}>
                    <line
                        stroke={STROKE[variant]}
                        strokeDasharray={2}
                        strokeDashoffset={0}
                        id={`loading-waveform-${id}`}
                        x1="100%"
                        y1="50%"
                        x2="0%"
                        y2="50%"
                    />
                </svg>
                {text ? (
                    <Tag className={styles.loaderTag} variant="default">
                        {text}
                    </Tag>
                ) : null}
            </div>
        </div>
    ),
)
